/* eslint-disable max-lines, quotes */
export const OLYMPIC_VENUES = {
  "AQC": {
    "code": "AQC",
    "name": "Aquatics Centre",
    "label": "Aquatics Centre",
    "sports": ["DIV", "SWA"]
  },
  "ALX": {
    "code": "ALX",
    "name": "Pont Alexandre III",
    "label": "Pont Alexandre III",
    "sports": ["CRD", "OWS", "TRI"]
  },
  "BCY": {
    "code": "BCY",
    "name": "Bercy Arena",
    "label": "Bercy Arena",
    "sports": ["GAR", "GTR", "BKB"]
  },
  "BST": {
    "code": "BST",
    "name": "Saint-Quentin-en-Yvelines",
    "label": "Saint-Quentin-en-Yvelines",
    "sports": ["BMX"]
  },
  "CDM": {
    "code": "CDM",
    "name": "Champs de Mars Arena",
    "label": "Champs de Mars Arena",
    "sports": ["JUD", "WRE"]
  },
  "CPL": {
    "code": "CPL",
    "name": "Porte de La Chapelle Arena",
    "label": "Porte de La Chapelle Arena",
    "sports": ["BDM", "GRY"]
  },
  "DEF": {
    "code": "DEF",
    "name": "Paris La Defense Arena",
    "label": "Paris La Defense Arena",
    "sports": ["SWM"]
  },
  "ELA": {
    "code": "ELA",
    "name": "Elancourt Hill",
    "label": "Elancourt Hill",
    "sports": ["MTB"]
  },
  "EIF": {
    "code": "EIF",
    "name": "Eiffel Tower Stadium",
    "label": "Eiffel Tower Stadium",
    "sports": ["VBV"]
  },
  "GRP": {
    "code": "GRP",
    "name": "Grand Palais",
    "label": "Grand Palais",
    "sports": ["FEN", "TKW"]
  },
  "INV": {
    "code": "INV",
    "name": "Invalides",
    "label": "Invalides",
    "sports": ["ARC", "ATH"]
  },
  "LBO": {
    "code": "LBO",
    "name": "Le Bourget Climbing Venue",
    "label": "Le Bourget Climbing Venue",
    "sports": ["CLB"]
  },
  "LC1": {
    "code": "LC1",
    "name": "La Concorde 1",
    "label": "La Concorde 1",
    "sports": ["BK3", "BKG"]
  },
  "LC2": {
    "code": "LC2",
    "name": "La Concorde 2",
    "label": "La Concorde 2",
    "sports": ["BMF"]
  },
  "LC3": {
    "code": "LC3",
    "name": "La Concorde 3",
    "label": "La Concorde 3",
    "sports": ["SKB"]
  },
  "LC4": {
    "code": "LC4",
    "name": "La Concorde 4",
    "label": "La Concorde 4",
    "sports": ["SKB"]
  },
  "LIL": {
    "code": "LIL",
    "name": "Pierre Mauroy Stadium",
    "label": "Pierre Mauroy Stadium",
    "sports": ["HBL"]
  },
  "RGA": {
    "code": "RGA",
    "name": "Roland-Garros Stadium",
    "label": "Roland-Garros Stadium",
    "sports": ["BOX"]
  },
  "SP1": {
    "code": "SP1",
    "name": "South Paris Arena 1",
    "label": "South Paris Arena 1",
    "sports": ["VVO"]
  },
  "SP6": {
    "code": "SP6",
    "name": "South Paris Arena 6",
    "label": "South Paris Arena 6",
    "sports": ["WLF"]
  },
  "STA": {
    "code": "STA",
    "name": "Stade de France",
    "label": "Stade de France",
    "sports": ["RU7", "ATH"]
  },
  "TRO": {
    "code": "TRO",
    "name": "Trocadéro",
    "label": "Trocadéro",
    "sports": ["ATH", "CRD"]
  },
  "VEL": {
    "code": "VEL",
    "name": "Saint-Quentin-en-Yvelines National Velodrome",
    "label": "National Velodrome",
    "sports": ["CTR"]
  },
  "VNS": {
    "code": "VNS",
    "name": "Vaires-sur-Marne Nautical Stadium - Flat Water",
    "label": "Flat Water",
    "sports": ["ROW", "CSP"]
  },
  "VWW": {
    "code": "VWW",
    "name": "Vaires-sur-Marne Nautical Stadium - White Water",
    "label": "White Water",
    "sports": ["CSL"]
  },
  "YDM": {
    "code": "YDM",
    "name": "Yves-du-Manoir Stadium",
    "label": "Yves-du-Manoir Stadium",
    "sports": ["HOC"]
  }
}
